export default __webpack_public_path__ + "static/media/arrow-purple-right-large-icon.382055e5.svg";